module.exports = __webpack_public_path__ + "static/media/Img_info_9D1E14.d4dc3be1.jpg";